<template>
  <v-select
    v-model="internalValue"
    :items="approachesTypes"
    :multiple="multiple"
    :clearable="clearable"
    :label="label"
    :loading="loading"
    :disabled="disabled"
    box
    flat
    success
    hide-details
    class="text-details-none"
  >
    <template v-slot:selection="{ item, index }">
      <span v-if="index === 0" class="mr-1">
        {{ item }}
      </span>

      <span v-if="index === 1" class="grey--text caption">
        (+{{ internalValue.length - 1 }}
        {{ internalValue.length === 2 ? "outro" : "outros" }})
      </span>
    </template>
  </v-select>
</template>

<script>
export default {
  name: "SelectApproachTypes",
  props: {
    value: {
      type: [Array, String],
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: "Tipo de abordagem",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      approachesTypes: [
        "SMS",
        "PUSH",
        "EMAIL",
        "CALL_CELLPHONE",
        "CALL_PHONE",
        "WHATSAPP",
        "INCENTIVE_PUSH",
        "INCENTIVE_SMS",
        "INCENTIVE_WHATSAPP",
        "INCENTIVE_EMAIL",
      ],
    };
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        this.$emit("change", val);
      },
    },
  },
};
</script>
